module.exports = __webpack_public_path__ + "static/media/menu-card-2.87c7ebfe.jpg";